// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "@fortawesome/fontawesome-free/js/all";

function isInteractiveElement(target) {
	return target instanceof Element && Boolean(target.closest("input, textarea, select, [contenteditable='true']"));
}

function hasScrollableParent(target) {
	if (!(target instanceof Element)) return false;

	let node = target;
	while (node && node !== document.body) {
		const style = window.getComputedStyle(node);
		const canScrollY = /(auto|scroll)/.test(style.overflowY);
		if (canScrollY && node.scrollHeight > node.clientHeight && node.scrollTop > 0) {
			return true;
		}
		node = node.parentElement;
	}

	return false;
}

function setupMobilePullToRefresh() {
	if (window.__mobilePullToRefreshSetup) return;
	window.__mobilePullToRefreshSetup = true;

	const MOBILE_QUERY = "(max-width: 767px)";
	const PULL_THRESHOLD_PX = 65;
	let startY = null;
	let currentPullDistance = 0;
	let shouldTrack = false;
	let didTriggerReload = false;

	function isAtTop() {
		return window.scrollY <= 0 &&
			document.documentElement.scrollTop <= 0 &&
			document.body.scrollTop <= 0;
	}

	document.addEventListener("touchstart", (event) => {
		if (!window.matchMedia(MOBILE_QUERY).matches) return;
		if (!isAtTop()) return;

		const touch = event.touches[0];
		if (!touch) return;

		const target = event.target;
		if (isInteractiveElement(target) || hasScrollableParent(target)) return;

		startY = touch.clientY;
		currentPullDistance = 0;
		shouldTrack = true;
		didTriggerReload = false;
	}, { passive: true });

	document.addEventListener("touchmove", (event) => {
		if (!shouldTrack || startY === null) return;

		const touch = event.touches[0];
		if (!touch) return;

		currentPullDistance = touch.clientY - startY;

		if (currentPullDistance < 0) {
			shouldTrack = false;
			startY = null;
			currentPullDistance = 0;
			didTriggerReload = false;
			return;
		}

		if (!didTriggerReload && currentPullDistance >= PULL_THRESHOLD_PX && isAtTop()) {
			didTriggerReload = true;
			window.location.reload();
		}
	}, { passive: true });

	document.addEventListener("touchend", () => {
		if (!didTriggerReload && shouldTrack && currentPullDistance >= PULL_THRESHOLD_PX && isAtTop()) {
			window.location.reload();
		}

		startY = null;
		currentPullDistance = 0;
		shouldTrack = false;
		didTriggerReload = false;
	}, { passive: true });
}

setupMobilePullToRefresh();
